import React from 'react';
import { observer } from 'mobx-react-lite';

const Departure = observer(({ maxJibDeparture, minJibDeparture }) => {
  if (!(maxJibDeparture || minJibDeparture)) return null;

  const stringDeparture = [minJibDeparture, maxJibDeparture].filter((el) => el).join(' - ');

  return (
    <tr>
      <td className="pale">Вылет стрелы</td>
      <td>
        <span>{`${stringDeparture}`} м</span>
      </td>
    </tr>
  );
});

export default Departure;
